export const getGraphListApi = () => `/analytics/module/graphs`;

export const getMaintenanceChecksApi = (assetTypeName, assetId) =>
  assetTypeName && assetId
    ? `config/maintenance-checks/${assetTypeName}/${assetId}/`
    : `config/maintenance-checks/lessor/`;


const appendQueryString = (basePath, query) => {
  if (!query || typeof query !== "object") return basePath;
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    if (Array.isArray(value)) {
      value.forEach((v) => {
        if (v !== null && v !== undefined && v !== "") params.append(key, v);
      });
    } else {
      params.append(key, value);
    }
  });
  const str = params.toString();
  return str ? `${basePath}?${str}` : basePath;
};

// Called per graph uuid to fetch its echart options from the backend (optional filter query)
export const getGraphOptionsApi = (uuid, query) => {
  return appendQueryString(`/analytics/graphDetails/${uuid}`, query);
};

export const extractMaintenanceEvents = (data) => {
  const events = data?.[0]?.maintenance_events?.length > 0 ? data[0].maintenance_events : Array.isArray(data) ? data : [];
  const seen = new Set();
  return events.filter((event) => {
    if (event?.id == null || seen.has(event.id)) return false;
    seen.add(event.id);
    return true;
  });
};

export const pinGraphApi = () => `/analytics/module/graphs/pin`;

export const unpinGraphApi = () => `/analytics/module/graphs/unpin`;

export const getReserveRateEscalationApi = (leaseSlug, reserveRateSlug) => `lease/${leaseSlug}/reserve_accounts/${reserveRateSlug}/escalation/`;
